import {
  AdyenCheckout,
  Dropin,
  type CoreConfiguration,
} from "@adyen/adyen-web";
import "@adyen/adyen-web/styles/adyen.css";
import React, { useEffect, useState } from "react";
import {
  adyenAlipayHKOrPaymeSingleCheckout,
  getMerchantAccountPaymentMethods,
} from "../../../apis/subscription";
import { customShowToast } from "../../../helper/toast";
import BaseLabel from "../baseLabel";

const ADYEN_CLIENT_KEY = process.env.REACT_APP_ADYEN_CLIENT_KEY;
const ADYEN_ENV = process.env.REACT_APP_ENV === "production" ? "live" : "test";

interface IAdyenAlipayHKProps {
  paymentId?: string;
  returnUrl?: string;
}

const AdyenAlipayHK: React.FC<IAdyenAlipayHKProps> = (props) => {
  const { paymentId, returnUrl } = props;
  const [isIniting, setIsiniting] = useState(true);

  const createAdyenSession = async () => {
    try {
      if (!paymentId) {
        return;
      }
      const sessionData = await adyenAlipayHKOrPaymeSingleCheckout(
        +paymentId,
        returnUrl ?? `${window.location.href}?aip=hk`,
      );

      // @ts-ignore
      if (sessionData.message === "not_payment_found") {
        customShowToast("此帳單已失效，請聯繫客服", "error");
        return;
      }

      // @ts-ignore
      if (sessionData.message === "monthly_order_canceled") {
        customShowToast("訂閱已取消", "error");
        return;
      }

      if (sessionData) {
        adyenAlipayInit(sessionData);
      }
    } catch (error) {}
  };

  const adyenAlipayInit = async (sessionData: any) => {
    try {
      console.log("adyen alipay init");

      setIsiniting(true);
      const supportedPaymentMethods = await getMerchantAccountPaymentMethods();
      const configuration: CoreConfiguration = {
        clientKey: ADYEN_CLIENT_KEY,
        session: {
          id: sessionData.id,
          sessionData: sessionData.sessionData,
        },
        environment: ADYEN_ENV,
        paymentMethodsResponse: supportedPaymentMethods,
        allowPaymentMethods: ["alipay_hk"],
        locale: "en-US", // Locale for the payment form
        countryCode: "HK",
        risk: {
          enabled: true,
        },
        analytics: {
          enabled: true,
        },
      };

      // Initialize AdyenCheckout
      const checkout = await AdyenCheckout(configuration);

      // Create an instance of Drop-in.
      new Dropin(checkout).mount(`#alipay-dropin${paymentId}`);
    } catch (error) {
      setIsiniting(false);
    } finally {
      setIsiniting(false);
    }
  };

  // init adyen card element when tab changed
  useEffect(() => {
    createAdyenSession();
  }, [paymentId]);

  return (
    <div>
      <BaseLabel
        text="*付款結果可能會受到銀行處理時間影響，請耐心等候。"
        className="text-mainYellow"
      />
      {isIniting && <div className="skeleton h-[122px] w-full"></div>}
      <div id={`alipay-dropin${paymentId}`} />
    </div>
  );
};

export default AdyenAlipayHK;
